import {
	Component,
	ElementRef,
	Input,
	input,
	OnChanges,
	OnInit,
	output,
	SimpleChanges,
	viewChild,
} from "@angular/core";
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { AutoGrowDirective } from "common/autoGrow/autogrow.directive";
import { ButtonComponent } from "common/buttons/button.component";
import { TrimDirective } from "common/trim.directive";
import { DisclaimerMainComponent } from "common/disclaimer/main/disclaimer-main.component";

export interface SendButtonConfiguration {
	iconStyles: Record<string, string>;
	buttonStyles: Record<string, string>;
}

@Component({
	selector: "stages-chatbot-input",
	templateUrl: "./chatbot-input.component.html",
	styleUrls: ["./chatbot-input.component.scss"],
	imports: [
		ReactiveFormsModule,
		TranslateModule,
		AutoGrowDirective,
		ButtonComponent,
		TrimDirective,
		DisclaimerMainComponent,
	],
})
export class ChatbotInputComponent implements OnInit, OnChanges {
	readonly chatbotInput = viewChild.required<ElementRef>("chatbotInput");
	chatbotFormGroup: UntypedFormGroup = new UntypedFormGroup({});

	protected _sendButtonConfiguration: SendButtonConfiguration = { iconStyles: {}, buttonStyles: {} };

	readonly chatbotInputPlaceholder = input<string>("chatbot.input.placeholder");

	@Input()
	disableSendButton: boolean | null = false;

	readonly inputDisabled = input<boolean | null>(false);

	readonly focused = input<boolean | null>(false);

	readonly sendButtonConfiguration = input<SendButtonConfiguration | null>(null);

	readonly submitQuestion = output<string>();

	readonly abortStreaming = output<void>();

	ngOnInit(): void {
		this.chatbotFormGroup.addControl("chatbot-input", new UntypedFormControl(""));
	}

	ngOnChanges(changes: SimpleChanges): void {
		const chatbotInput = this.chatbotInput();
		if (changes.focused && chatbotInput) {
			chatbotInput.nativeElement.focus();
		}

		if (changes.sendButtonConfiguration) {
			this._sendButtonConfiguration = changes.sendButtonConfiguration.currentValue;
		}
	}

	onValueChange(): void {
		//console.log(this.chatbotFormGroup.get("chatbot-input")!.value);
	}

	onCtrlEnter(): void {
		const chatbotInputControl = this.chatbotFormGroup.get("chatbot-input")!;
		chatbotInputControl.setValue(`${chatbotInputControl.value}\n`);
	}

	onEnter(event?: Event): void {
		const chatbotInputControl = this.chatbotFormGroup.get("chatbot-input")!;
		if (chatbotInputControl.value.length === 0 || this.disableSendButton === true || this.inputDisabled()) {
			return;
		}
		this.submitQuestion.emit(chatbotInputControl.value);
		chatbotInputControl.setValue("");
		event?.preventDefault();
	}

	onStop(): void {
		// TODO: The 'emit' function requires a mandatory void argument
		this.abortStreaming.emit();
	}
}
